module.exports = __webpack_public_path__ + "img/bidToBatAndMacFlow.34dcd39b.gif";